import React, { useMemo, useRef, useState, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './Access.css';

function buildVless(user) {
  if (!user?.subscriptionUrl) {
    return null;
  }
  return user.subscriptionUrl;
}
export default function Access({ user }){
  const vless = useMemo(()=>buildVless(user),[user]);
  const [hidden, setHidden] = useState(false);
  const toastRef = useRef(null);
  const qrRef = useRef(null); // ref на <QRCodeSVG/>

  const showToast = useCallback((text) => {
    const t = toastRef.current;
    if(!t) return;
    t.textContent = text;
    t.classList.add('access-toast-show');
    window.clearTimeout(t._tm);
    t._tm = window.setTimeout(()=>t.classList.remove('access-toast-show'), 1400);
  },[]);

  const copyText = useCallback(async (text) => {
    try{
      await navigator.clipboard.writeText(text);
      showToast('Ссылка скопирована');
    }catch{
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta);
      ta.select(); document.execCommand('copy'); ta.remove();
      showToast('Ссылка скопирована');
    }
  },[showToast]);

  const saveQrSvg = useCallback(async () => {
    const svg = qrRef.current?.querySelector('svg');
    if(!svg){ showToast('QR недоступен'); return; }
    const xml = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([xml], {type:'image/svg+xml'});
    try{
      await navigator.clipboard.write([new ClipboardItem({'image/svg+xml': blob})]);
      showToast('QR сохранён в буфер (SVG)');
      return;
    }catch(_) {  }
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'vless-qr.svg';
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    showToast('QR скачан (SVG)');
  },[showToast]);

  if(!vless){
    return (
      <section className="access-empty">
        <h2>Доступы</h2>
        <div className="access-sub">Для генерации ссылки нужен UUID</div>
      </section>
    );
  }

  return (
    <>
      <section className="access-hero">
        <div className="access-hero-badge">Доступы</div>
        <h1 className="access-hero-title">Ваши QR-код и VLESS ссылка для подключения</h1>
        <div className="access-hero-sub">Отсканируйте QR код мобильным клиентом или скопируйте и вставьте VLESS ссылку</div>
      </section>

      <section className="access-card" role="region" aria-labelledby="access-title">
        <header className="access-head">
          <div id="access-title" className="access-title">Доступы для {user.username}</div>
        </header>
        <div className="access-grid">
          <div>
            <div className="access-qrwrap" ref={qrRef} aria-label="QR-код">
              <QRCodeSVG value={vless} size={180} includeMargin />
            </div>

          </div>

          <div>
            <div className="access-row" style={{marginTop:0}}>
              <span>Подписка (VLESS)</span>
              <div style={{display: 'flex', gap: 8}}>
                <a className="access-btn v2ray-btn" target={'blank'} href={'v2raytun://import/' + vless}>Открыть в v2RayTun</a>
                <button className="access-btn" onClick={() => copyText(vless)}>Скопировать</button>
              </div>
            </div>

            <pre className="access-code" style={{filter: hidden ? 'blur(6px)' : 'none'}}>{vless}</pre>
          </div>
        </div>

        <div className="access-accent" aria-hidden="true" />
      </section>

      <div className="access-toast" ref={toastRef}>Скопировано</div>
    </>
  );
}
